import { Component, OnInit }  from "@angular/core";
import { environment }        from "../environments/environment";
import { SettingsService }    from "./services/settings.service";
import { NavigatorService }   from "./services/navigator.service";
import { AppStatusService }   from "./services/app-status.service";
import { fadeAnimation }      from "./animations";
import { TranslationService } from "../shared/services/translation.service";
import { DataApi }            from "./services/api/data-api.service";
import { sleep }              from "../shared/utils/core-utils";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [fadeAnimation]
})
export class AppComponent implements OnInit {

    constructor(private appStatusService: AppStatusService,
                private navigator: NavigatorService,
                private settingsService: SettingsService,
                private translationService: TranslationService,
				private dataApi: DataApi) {
    }

    async ngOnInit() {
        document.title = environment.appName + ' ' + environment.appVersion;
        // Trick to disable pinch zoom by touch, works on Webkit (by Dominik/Lunixo):
		document.addEventListener('touchmove', (event: TouchEvent) => {
			// Disable 2-finger gestures
			if (event.touches.length > 1)
				event.preventDefault();
		}, { passive: false });
        // Init settings, translator, status service and navigator
        await this.settingsService.init();
        await this.initTranslationService();
        await this.appStatusService.startSyncWithServer();
        this.navigator.start();
    }

    async initTranslationService() {
		while (true) {
			try {
				const languagePack = await this.dataApi.getLanguagePack();
				if (languagePack == null)
					throw new Error("Not loaded");
				console.log('Language pack loaded');
				this.translationService.setLanguagePack(languagePack);
				break;
			} catch (ex) {
				console.log('Loading language pack failed, trying again: ' + ex);
				await sleep(2000);
			}
		}
	}

}
